import { render } from "./ExampleTabs.vue?vue&type=template&id=cc8ef3fa"
import script from "./ExampleTabs.vue?vue&type=script&lang=ts"
export * from "./ExampleTabs.vue?vue&type=script&lang=ts"
script.render = render

export default script